import Vue from "vue";
import VueRouter from "vue-router";
import { validateToken } from "@/global";

import store from './store';

import Home from "@/components/home/Home";
import AdminPages from "@/components/admin/AdminPages";
import ProfilePage from "@/components/admin/ProfilePage";
import Auth from "@/components/auth/Auth";
import Dashboard from "@/components/dashboard/dashboard";
import ChangePassword from "@/components/password/changePassword.vue";
import ProductionPlan from "@/components/plan/ProductionPlan.vue";
import WeightIndicator from "@/components/weightIndicator/WeightIndicator.vue";
import GridLayoutMonitoring from "@/components/gridLayoutMonitoring/GridLayoutMonitoring.vue";
import Occurrence from "@/components/occurrence/occurrence";
import OccurrenceTree from "@/components/occurrencetree/OccurrenceTree";
import SimulatorConfig from "@/components/simulator/simulatorConfig.vue";
import ImportScenario from "@/components/scenario/importScenario.vue";
import ExportScenario from "@/components/scenario/exportScenario.vue";
import LoadScenario from "@/components/scenario/loadScenario.vue";
import SaveScenario from "@/components/scenario/saveScenario.vue";
import ProductionPlanItem from "@/components/ProductionPlanItem/ProductionPlanItem.vue";
import ProductionPlanMapEditor from "@/components/ProductionPlanItem/ProductionPlanMapEditor.vue";
import ProductionPlanEquationEditor from "@/components/ProductionPlanItem/ProductionPlanEquationEditor.vue";
import RegisterInputs from "@/components/registerInputs/registerInputs.vue";
import HarvestPlan from "@/components/harvestPlan/HarvestPlan.vue";
import MaterialInputPlan from "@/components/materialInputPlan/MaterialInputPlan.vue";
import PriceProjectionPlan from "@/components/priceProjectionPlan/PriceProjectionPlan.vue";
import ProductionPlanCreator from "@/components/productionPlanCreator/productionPlanCreator.vue";
import SimulatorResult from "@/components/productionPlanCreator/SimulatorResult.vue";
import Flowchart from "@/components/flowchart/FlowChart.vue";
import HarvestPlanView from "@/components/harvestPlanView/harvestPlanView.vue";
import MaterialInputView from "@/components/materialInputview/materialInputView.vue"
import MaterialInputPriceView from "@/components/materialInputPriceView/materialInputPriceView.vue"
import LTconfigurator from "@/components/LTconfigurator/LTconfigurator.vue";
import BillOfMaterial from "@/components/billOfMaterial/BillOfMaterial.vue"
import ProductionMonitoring from "@/components/productionMonitoring/ProductionMonitoring.vue"
import GridOccurrenceMonitoring from "@/components/gridOccurrenceMonitoring/GridOccurrenceMonitoring.vue"
import Product from "@/components/analytics/Product.vue"
import OccurrenceGrid from "@/components/occurrenceGrid/occurrenceGrid.vue"
import Greatness from "@/components/analytics/Greatness.vue"
import Process from "@/components/analytics/Process.vue"
import Equipment from "@/components/analytics/Equipment.vue"
import AnalysisGrid from "@/components/analytics/AnalysisGrid.vue"
import PAPContent from "@/components/pap/papContent.vue"
import TriggerManegement from "@/components/triggerManagement/TriggerManagement.vue"
import SeasonalIndicatorSetup from "@/components/seasonalIndicatorSetup/SeasonalIndicatorSetup.vue"
import KpiConfiguration from "../components/kpiConfiguration/kpiConfiguration.vue"
import ManageIndicator from "../components/dashboard/manageIndicator/ManageIndicator.vue"
import AdherenceIndicators from "../components/productionMonitoring/AdherenceIndicators.vue"
import AdherenceIndicatorsGDI from "../components/productionMonitoring/AdherenceIndicatorsGDI.vue"
import EditIndicators from '../components/indicatorEditor/Edition.vue'
import CreateIndicators from '../components/indicatorEditor/Creation.vue'
import DashboardRTA from '../components/rta/DashboardRta.vue'
import ConsultarRTA from '../components/rta/OpenRtaList.vue'
import DisparoGatilhosRTA from '../components/rta/RtaTriggersList.vue'
import ConfigureIndicatorRta from "../components/rta/ConfigureIndicatorRta.vue";
import DetailsRtaDealing from "../components/rta/DetailsRtaDealing.vue";
import ListIndicatorRta from "../components/rta/ListIndicatorRta.vue";
import CustomReports from "../components/customReports/customReports.vue";
import ArvoreDeInfluencia from "../components/customReports/influenceTree.vue";
import ChangeHistoryLogs from "../components/audit/viewSystemLogs/ChangeHistoryLogs.vue";

import axios from "axios";
import {
  //userKey
  urlMainAPI
} from "@/global";
import { clearAllData } from "../global";

Vue.use(VueRouter);

const routes = [{
    name: "home",
    path: "/",
    component: Home
  },
  {
    name: "auth",
    path: "/auth",
    component: Auth,
  },
  {
    path: "*",
    redirect: "/",
  },
  {
    name: "dashboard",
    path: "/dashboard/:type",
    component: Dashboard
  },
  {
    name: "password",
    path: "/password",
    component: ChangePassword
  },
  {
    name: "adminPages",
    path: "/admin",
    component: AdminPages,
    meta: {
      //requiresAdmin: true
      requiresAdmin: false
    }
  },
  {
    name: "adminProfilePages",
    path: "/adminProfile",
    component: ProfilePage,
    meta: {
      //requiresAdmin: true
      requiresAdmin: false
    }
  },
  {
    name: "plan",
    path: "/plan/:unit",
    component: ProductionPlan
  },
  {
    name: "weight",
    path: "/weight",
    component: WeightIndicator
  },
  {
    name: "monitoring",
    path: "/monitoring/:unit",
    component: GridLayoutMonitoring
  },
  {
    name: "reviewproduction",
    path: "/reviewproduction",
    component: Occurrence
  },
  {
    name: "occurrencetree",
    path: "/occurrencetree",
    component: OccurrenceTree
  },
  {
    name: "simulatorconfig",
    path: "/simulatorconfig",
    component: SimulatorConfig
  },
  {
    name: "importscenario",
    path: "/importscenario",
    component: ImportScenario
  },
  {
    name: "exportscenario",
    path: "/exportscenario",
    component: ExportScenario
  },
  {
    name: "loadscenario",
    path: "/loadscenario",
    component: LoadScenario
  },
  {
    name: "savescenario",
    path: "/savescenario",
    component: SaveScenario
  },
  {
    name: "productionplanitem",
    path: "/productionplanitem",
    component: ProductionPlanItem
  },
  {
    name: "productionplanmapeditor",
    path: "/productionplanmapeditor",
    component: ProductionPlanMapEditor
  },
  {
    name: "productionplanequationeditor",
    path: "/productionplanequationeditor",
    component: ProductionPlanEquationEditor
  },
  {
    name: "registerinputs",
    path: "/registerinputs",
    component: RegisterInputs
  },
  {
    name: "harvestplan",
    path: "/harvestplan",
    component: HarvestPlan
  },
  {
    name: "materialinputplan",
    path: "/materialinputplan",
    component: MaterialInputPlan
  },
  {
    name: "priceprojectionplan",
    path: "/priceprojectionplan",
    component: PriceProjectionPlan
  },
  {
    name: "productionplancreator",
    path: "/productionplancreator",
    component: ProductionPlanCreator
  },
  {
    name: "harvestplanview",
    path: "/harvestplanview",
    component: HarvestPlanView
  },
  {
    name: "materialinputview",
    path: "/materialinputview",
    component: MaterialInputView
  },
  {
    name: "simulatorresult",
    path: "/simulatorresult",
    component: SimulatorResult
  },
  {
    name: "flowchart",
    path: "/flowchart",
    component: Flowchart
  },
  {
    name: "ltconfigurator",
    path: "/ltconfigurator",
    component: LTconfigurator
  },
  {
    name: "billofmaterial",
    path: "/billofmaterial",
    component: BillOfMaterial
  },
  {
    name: "materialinputpriceview",
    path: "/materialinputpriceview",
    component: MaterialInputPriceView
  },
  {
    name: "ProductionMonitoring",
    path: "/productionmonitoring/:unit",
    component: ProductionMonitoring
  },
  {
    name: "occurrencemonitoring",
    path: "/occurrencemonitoring/:display",
    component: GridOccurrenceMonitoring
  },
  {
    name: "registrationproduct",
    path: "/Analytics/registrationproduct",
    component: Product
  },
  {
    name: "occurrencegrid",
    path: "/occurrencegrid",
    component: OccurrenceGrid   
  },
  {
    name: "managementgreatness",
    path: "/Analytics/managementgreatness",
    component: Greatness
   },
   {
    name: "registrationprocess",
    path: "/Analytics/registrationprocess",
    component: Process
  },
  {
    name: "registrationequipment",
    path: "/Analytics/registrationequipment",
    component: Equipment
  },
  {
    name: "analysis",
    path: "/Analytics",
    component: AnalysisGrid
  },
  {
    name: "areaspap",
    path: "/areaspap",
    component: PAPContent
  },
  {
    name: "triggermanagement",
    path: "/triggermanagement",
    component: TriggerManegement
  },
  {
    name: "seasonalindicatorsetup",
    path: "/seasonalindicatorsetup",
    component: SeasonalIndicatorSetup
  },
  {
    name: "kpiconfiguration",
    path: "/kpiconfiguration",
    component: KpiConfiguration
  },
  {
    name: "manageindicator",
    path: "/manageindicator",
    component: ManageIndicator
  },
  {
    name: "adherenceindicators",
    path: "/adherenceindicators/:unitId",
    component: AdherenceIndicators
  },
  {
    name: "adherenceindicatorsgdi",
    path: "/adherenceindicatorsgdi",
    component: AdherenceIndicatorsGDI
  },
  {
    name: "editindicators",
    path:"/indicatorsEditor/edition",
    component: EditIndicators
  },
  {
    name: "createindicators",
    path:"/indicatorsEditor/creation",
    component: CreateIndicators
  },
  {
    name: "rtadashboard",
    path:"/rta/dashboard",
    component: DashboardRTA
  },
  {
    name: "rtalist",
    path:"/rta/list/:indicatorId?",
    component: ConsultarRTA
  },
  {
    name: "rtatriggers",
    path:"/rta/triggers",
    component: DisparoGatilhosRTA
  },
  {
    name: "rtaconfiguration",
    path:"/rta/configuration",
    component: ConfigureIndicatorRta
  },
  {
    name: "rtadetails",
    path:"/rta/details/:rtaId",
    component: DetailsRtaDealing,
    props:true
  },
  {
    name:"rtaindicatorslist",
    path:"/rta/indicators",
    component: ListIndicatorRta
  },
  {
    name: "relatoriospersonalizados",
    path:"/relatoriospersonalizados",
    component: CustomReports
  },
  {
    name: "viewInfluenceTree",
    path:"/viewInfluenceTree",
    component: ArvoreDeInfluencia
  },
  {
    name: "changehistorylogs",
    path:"/changehistorylogs",
    component: ChangeHistoryLogs
  }
];
  
const router = new VueRouter({ 
  base: process.env.VUE_APP_DIRECTORY ? "/" + process.env.VUE_APP_DIRECTORY + "/" : "./", 
  mode: "history",
  routes
});

// console.log('process.env :>> ', process.env);
// console.log('router :>> ', router);

router.beforeEach(async (to, from, next) => {
  const json = localStorage.getItem("userKey");
  var isTokenOK = await validateToken()
  // console.log('isTokenOK :>> ', isTokenOK);

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json);
    user && user.user.admin ?
      next() :
      next({
        path: "/"
      });
  } 
  else if (isTokenOK && to.matched.some(record => record.path == "/auth")){
    console.log("entrou na rota auth");
    next({ path: "/Dashboard" })
  }
  else {
    next();
  }
});

let time;
// eslint-disable-next-line no-unused-vars
let startTime;
// eslint-disable-next-line no-unused-vars
let endTime;

function inactivityTime(idleTime) {
  startTime = Date.now()

  function resetTimer() {
    clearTimeout(time);
    time = setTimeout(logout, 60000 * idleTime);
    endTime = (Date.now() - startTime)/1000
    startTime = Date.now()
    endTime = null
  }

  function logout() {
    endTime = (Date.now() - startTime)/1000
    startTime = null
    endTime = null
    disconnectUser();
  }

  time = setTimeout(logout, 60000 * idleTime);
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;
}

router.afterEach((to) => {
  
  clearTimeout(time);
  
  if(store.state.user){
    const idleTime = store.state.user ? Number(store.state.user.Downtime) : 0; // Recupera o tempo do user
    const isAllowedIdle = store.state.user.Permissions.naoverificarinatividade.allowed

    if (to.name == 'auth' || isAllowedIdle) {
      document.onmousemove = null;
      document.onkeypress = null;
      return;
    }
    inactivityTime(idleTime);
    return;
  }
  // console.log("Sem usuário no store ...");
  return;
});

async function disconnectUser() {
  const user = store.state.user ? store.state.user : {};
  const obj = {};
  obj.userName = window.btoa(JSON.stringify(user.UserName));
  obj.system = user.role == "GDI" ? "G": "P";
  obj.unitId = parseInt(user.UnitId);
  const url = `${urlMainAPI}/disconnectuser`;
  await axios
    .post(url, obj)
    .then(() => {
      store.state.user = null;
      store.state.token = null;
      store.state.xml = null;
      store.state.system = null;

      clearTimeout(time);
      document.onmousemove = null;
      document.onkeypress = null;
      clearAllData()
      router.push({ name: "auth" });
    })
    .catch();
}

export default router;